var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLightSnsInsta(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12 8.8C10.3 8.8 8.8 10.3 8.8 12C8.8 13.7 10.3 15.2 12 15.2C13.7 15.2 15.2 13.7 15.2 12C15.2 10.3 13.7 8.8 12 8.8ZM16.1 2.5H8C4.9 2.5 2.5 4.9 2.5 7.9V15.9C2.5 19 4.9 21.4 8 21.4H16C19 21.4 21.4 19 21.4 15.9V7.9C21.5 4.9 19.1 2.5 16.1 2.5ZM12 17C9.2 17 7.1 14.8 7.1 12.1C7.1 9.4 9.3 7.1 12 7.1C14.8 7.1 16.9 9.3 16.9 12C16.9 14.7 14.8 17 12 17ZM17.1 8.1C16.5 8.1 16 7.6 16 7C16 6.4 16.5 5.9 17.1 5.9C17.7 5.9 18.2 6.4 18.2 7C18.2 7.6 17.7 8.1 17.1 8.1Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightSnsInsta);
export default __webpack_public_path__ + "static/media/light-sns-insta.f2427a5b592406432aca2da1a8f65351.svg";
export { ForwardRef as ReactComponent };